/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function QA(props) {
  let renderedQAs = [];
  for (let qa of props.qas) {
    renderedQAs.push(
      <div
        css={css`
          text-align: left;

          &:last-child {
            border: none;
          }
        `}
      >
        <h4
          css={css`
            font-family: ${globals.headlineFont};
            font-size: 14px;
            font-weight: bold;
            margin: 4px 0 0;
          `}
        >
          {qa.q}
        </h4>
        <p
          css={css`
            font-family: ${globals.bodyFont};
            font-size: 13px;
            margin: 4px 0 0 20px;
          `}
        >
          {qa.a}
        </p>
      </div>
    );
  }
  return (
    <div
      css={css`
        ${globals.card}
        padding: 0;
      `}
    >
      <div
        css={css`
          height: 27px;
          font-size: 18px;
          line-height: 23px;
          text-transform: uppercase;
          background-color: #000;
          text-align: left;
          font-weight: bold;
          font-family: ${globals.menuFont};
          color: #fff;
          font-size: 18px;
          line-height: 23px;
          padding-top: 1px;
          padding-left: 10px;
        `}
      >
        {"Q&A"}
      </div>
      <div
        css={css`
          padding: 10px;
          /* max-height: 550px; */
          /* overflow: scroll; */
        `}
      >
        <p
          css={css`
            margin-top: 0;
            text-align: left;
          `}
        >
          You asked, we answered. Here are some questions Bruins asked about
          what COVID-19 means for UCLA students.
        </p>
        {renderedQAs}
        <a
          href="https://dailybruin.com/2022/01/14/qa-effect-of-increasing-covid-19-cases-on-booster-shots-isolation-and-on-campus-living/"
          target="_blank"
          rel="noopener noreferrer"
          css={css`
            display: block;
            width: 100%;
            text-align: right;
            text-transform: uppercase;
            font-family: ${globals.menuFont};
            font-weight: bold;
            font-size: 11px;
            color: ${globals.DBblue};
            text-decoration: none;
            margin-top: 4px;

            &:hover {
              text-decoration: underline;
            }
          `}
        >
          READ ALL THE ANSWERS →
        </a>
      </div>
    </div>
  );
}
